import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/ForgotPassword.css";

export default function ForgotPassword({ onClose, email: initialEmail }) {
  const [step, setStep] = useState(1); // 1: mail, 2: kod, 3: şifre
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [passwordRules, setPasswordRules] = useState({
    minLength: false,
    hasUpper: false,
    hasLower: false,
    hasNumber: false,
    hasSpecial: false,
  });

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);

    setPasswordRules({
      minLength: value.length >= 6,
      hasUpper: /[A-ZÇĞİÖŞÜ]/.test(value),
      hasLower: /[a-zçğıöşü]/.test(value),
      hasNumber: /[0-9]/.test(value),
      hasSpecial: /[^a-zA-ZçğıöşüÇĞİÖŞÜ0-9]/.test(value),
    });
  };

  // Giriş popup’ından gelen email varsa otomatik doldur
  useEffect(() => {
    if (initialEmail) {
      setEmail(initialEmail);
    }
  }, [initialEmail]);

  const handleSendEmail = async () => {
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/forgotpassword`, {
        email,
      });
      setMessage("📨 Kod e-posta adresinize gönderildi.");
      setError("");
      setStep(2);
    } catch (err) {
      setError("❌ E-posta adresi bulunamadı.");
      setMessage("");
    } finally {
      setLoading(false);
    }
  };

  const handleContinueWithCode = () => {
    if (!code) {
      setError("❗ Kod alanı boş olamaz.");
      return;
    }
    setStep(3);
    setError("");
    setMessage("✅ Kod alındı, şimdi yeni şifre belirleyebilirsin.");
  };

  const handleResetPassword = async () => {
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/resetpassword`, {
        email,
        code,
        newPassword,
        newPasswordConfirm,
      });
      setMessage("✅ Şifren başarıyla sıfırlandı.");
      setError("");
      setTimeout(() => onClose(), 2000);
    } catch (err) {
      setError("❌ Kod geçersiz veya şifreler uyuşmuyor.");
      setMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-popup-forgot">
        <button className="sifre-close-btn" onClick={onClose}>×</button>
        <h3>🔐 Şifremi Unuttum</h3>

        {/* ADIM 1: Mail gir */}
        {step === 1 && (
          <>
            <input
              type="email"
              placeholder="E-posta adresinizi girin"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button onClick={handleSendEmail} disabled={loading}>
              {loading ? "Gönderiliyor..." : "Kod Gönder"}
            </button>
          </>
        )}

        {/* ADIM 2: Kod gir */}
        {step === 2 && (
          <>
            <input
              type="text"
              placeholder="Mail adresinize gelen kodu girin"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <button onClick={handleContinueWithCode}>
              Devam Et
            </button>
          </>
        )}

        {/* ADIM 3: Yeni şifre belirle */}
        {step === 3 && (
          <>
            <div className="password-input-wrapper">
              <input
                type={showNewPassword ? "text" : "password"}
                value={newPassword}
                onChange={handlePasswordChange}
                required
                placeholder="Yeni şifre"
              />
              <span
                className="password-toggle"
                onClick={() => setShowNewPassword((prev) => !prev)}
              >
                {showNewPassword ? "Gizle" : "Göster"}
              </span>
            </div>

            <div className="password-input-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Yeni şifre (tekrar)"
                value={newPasswordConfirm}
                onChange={(e) => setNewPasswordConfirm(e.target.value)}
                className="password-input"
              />
              <span
                className="password-toggle"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              >
                {showConfirmPassword ? "Gizle" : "Göster"}
              </span>
            </div>
            
            <div className="password-rules">
              <div className={passwordRules.minLength ? "rule passed" : "rule"}>
                {passwordRules.minLength ? "✔️" : "⭕"} En az 6 karakter
              </div>
              <div className={passwordRules.hasUpper ? "rule passed" : "rule"}>
                {passwordRules.hasUpper ? "✔️" : "⭕"} Büyük harf (A-Z)
              </div>
              <div className={passwordRules.hasLower ? "rule passed" : "rule"}>
                {passwordRules.hasLower ? "✔️" : "⭕"} Küçük harf (a-z)
              </div>
              <div className={passwordRules.hasNumber ? "rule passed" : "rule"}>
                {passwordRules.hasNumber ? "✔️" : "⭕"} Rakam (0-9)
              </div>
              <div className={passwordRules.hasSpecial ? "rule passed" : "rule"}>
                {passwordRules.hasSpecial ? "✔️" : "⭕"} Özel karakter (!@#...)
              </div>
            </div>


            <button onClick={handleResetPassword} disabled={loading}>
              {loading ? "Sıfırlanıyor..." : "Şifreyi Sıfırla"}
            </button>
          </>
        )}

        {/* Bilgi mesajları */}
        {message && <p className="success">{message}</p>}
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
}
